import CoachDashboard from './CoachDashboard';

export default CoachDashboard;
